<template>
  <div class="mark">
    <span> {{ name }}</span>
  </div>
</template>
<script>
export default {
  name: "wx-mark",
  props: {
    name: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped lang='less'>
.mark {
  background: @co2;
  color: white;
  display: inline-block;
  height: 20px;
  padding: 0 6px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
}
@media (max-width: 1000px) {
  .mb_mark() !important;
}
.mb_mark {
  .mark {
    white-space: nowrap;
    span {
      transform: scale(0.9) !important;
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mark/index.vue